export default __webpack_public_path__ + "static/media/kitchen5-beforeE-480w.99ca03e0.png";